module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAv4+f8N2Jr+e7b18zHhb3q1NP8KA4fgAAAH1JREFUOMvt0zsOgCAURNGHPsT/j/3vVSMmUwAZGhMLbjfJaUeiln1Ttwhttf7OrhR2/qmjcAhwoNAEaCqs8AN4tKE+wP6dZwTVJ9PcBVD2Ek3KNYIgmYNkDpI5SOYgqYOEIxKOSTgm4UjjKP9qdqYgN4v1RVnRMqgyaZGbLuJ+HdzXnyf3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_btn.png
// module id = vKk5
// module chunks = 1